import React, { useState } from "react";

export const McqOptions = ({
  questionIndex,
  question,
  onOptionsChange, // Replace setData with this callback
}) => {
  const [validationErrors, setValidationErrors] = useState({});
  const [rawOptionsInput, setRawOptionsInput] = useState([]);
  
  const handleSingleOptionChange = (questionIndex, optionIndex, e) => {
    const value = e.target.value;

    setRawOptionsInput((prev) => {
      const currentOptions = prev[questionIndex] ?? [];
      const newOptions = [...currentOptions];
      newOptions[optionIndex] = value;
      const updatedRawOptions = [...prev];
      updatedRawOptions[questionIndex] = newOptions;
      return updatedRawOptions;
    });

    const updatedOptions = [...(rawOptionsInput[questionIndex] ?? [])];
    updatedOptions[optionIndex] = value;

    const trimmedOptions = updatedOptions
      .map((opt) => opt?.trim())
      .filter(Boolean);
    const hasDuplicates =
      new Set(trimmedOptions).size !== trimmedOptions.length;

    const hasRequiredEmpty =
      !updatedOptions[0]?.trim() || !updatedOptions[1]?.trim();

    setValidationErrors((prev) => ({
      ...prev,
      [questionIndex]: {
        duplicate: hasDuplicates,
        requiredEmpty: hasRequiredEmpty,
      },
    }));

    if (hasDuplicates || hasRequiredEmpty) return;

    // Call the callback with the new options and correct answer
    const newCorrectAnswer = 
      question.correct_answer && trimmedOptions.includes(question.correct_answer)
        ? question.correct_answer
        : trimmedOptions[0] || "";

    onOptionsChange({
      options: JSON.stringify(trimmedOptions),
      correct_answer: newCorrectAnswer
    });
  };

  return (
    <div className="col-span-12">
      <div className="space-y-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex flex-col">
            <label
              htmlFor={`option-${i}`}
              className="text-xs text-gray-500 mb-1"
            >
              Option {i + 1} {i < 2 && <span className="text-red-500">*</span>}
            </label>
            <input
              id={`option-${i}`}
              type="text"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
              placeholder={`Enter option ${i + 1}${i < 2 ? " (required)" : ""}`}
              value={
                rawOptionsInput[questionIndex]?.[i] ??
                JSON.parse(question.options || "[]")[i] ??
                ""
              }
              onChange={(e) => handleSingleOptionChange(questionIndex, i, e)}
            />
          </div>
        ))}
      </div>

      {/* Validation messages */}
      {validationErrors[questionIndex]?.duplicate && (
        <p className="mt-2 text-sm text-red-600">
          ❗ Duplicate options are not allowed.
        </p>
      )}
      {validationErrors[questionIndex]?.requiredEmpty && (
        <p className="mt-1 text-sm text-red-600">
          ❗ First two options are required.
        </p>
      )}
    </div>
  );
};